import React, { useEffect, Fragment, useState } from "react";
import { getStores } from '../services';
import Header from '../components/Header';
import Leftnav from '../components/Leftnav';
import Appfooter from '../components/Appfooter';
import Popupchat from '../components/Popupchat';
import Group from '../components/Group';
import Createpost from '../components/Createpost';
import Storyslider from '../components/Storyslider';
import Postview from '../components/Postview';
import { posts } from '../services/dummy-data';

const Home =() => {
    const [stores, setStores] = useState([]);
    const fetch = async () => {
        const theStores = await getStores();
        setStores(theStores.data)
    }
    useEffect(() => {
        fetch();
    },[])
    
        return (
            <Fragment> 
                <Header />
                <Leftnav />
                <div className="main-content right-chat-active">
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left">
                            <div className="row feed-body">
                                <div className="col-xl-8 col-xxl-9 col-lg-8">
                                    <Storyslider />
                                    <Createpost />
                                    {posts.map((post, index) => (
                                        <Postview key={index} id={post._id} postvideo="" postimage={post.image} avater={post.owner.picture} user={post.owner.firstName} time="Hace 22 min..." des={post.text} likes={post.likes} />
                                    ))}
                                    {/* <Memberslider /> */}
                                    {/* <Friendsilder /> */}
                                    {/* <Load /> */}
                                </div>
                                <div className="col-xl-4 col-xxl-3 col-lg-4 ps-lg-0">
                                    {/* <Friends />
                                    <Contacts /> */}
                                    <Group stores={stores} />
                                    {/* <Events /> */}
                                    {/* <Profilephoto /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {<Popupchat />}
                {<Appfooter />} 
            </Fragment>
        );
    }

export default Home;